<template>
  <v-list-item to="/maintenance">
    <v-list-item-icon v-if="maria">
      <img :src="require('@/assets/icons/mar.ia-cor.svg')" alt="maria" />
    </v-list-item-icon>
    <v-list-item-icon v-else>
      <mf-icon fill :icon="icon" />
    </v-list-item-icon>
    <v-list-item-content class="body-2">{{ text }}</v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'SideMenuMaintenanceItem',
  components: {},
  props: {
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    maria: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.theme--light.v-list-item--active:before {
  opacity: 0 !important;
}
</style>
